import { defaultEntityRender } from '../utilities';
var HolyRender = (function () {
    function HolyRender(entityTemplate) {
        if (entityTemplate === void 0) { entityTemplate = defaultEntityRender; }
        this.entityTemplate = entityTemplate;
    }
    HolyRender.prototype.mount = function (options) {
        var el = options.el;
        var rate = options.rate;
        var last = rate - Math.floor(rate);
        rate = Math.floor(rate);
        var starsTemplate = '';
        for (var i = 0; i < 5; i++) {
            if (i < rate) {
                starsTemplate += this.entityTemplate(options);
            }
            else if (last) {
                starsTemplate += this.entityTemplate(options, last);
                last = 0;
            }
            else {
                starsTemplate += this.entityTemplate(options, 0);
            }
        }
        el.innerHTML = "<div class=\"holy-stars\">".concat(starsTemplate, "</div>");
    };
    return HolyRender;
}());
export { HolyRender };
export var defaultUniversalRender = new HolyRender();
//# sourceMappingURL=holy-render.js.map